import MainComponent from "components/Main";
import Button from "components/Button";
//import CheckBox from "components/CheckBox";
import PropTypes from 'prop-types';

import Avatar from "components/Avatar";
//import Rating from "components/Rating";

import { ReactComponent as VipIcon } from 'icons/pages/app/vip.svg';
import { ReactComponent as EmployeeIcon } from 'icons/pages/app/patientStaff.svg';
import { ReactComponent as ChildrenIcon } from 'icons/pages/app/children.svg';
import { ReactComponent as SpecialInfoIcon } from 'icons/components/specialInfo.svg';
import { ReactComponent as PrintIcon } from 'icons/buttons/print.svg';
import { ReactComponent as SmileKeeperIcon } from 'icons/pages/app/smilkeeper.svg';
import { ReactComponent as AdvertIcon } from 'icons/pages/app/advert.svg';
import { ReactComponent as AdvertDisableIcon } from 'icons/pages/app/advertDisable.svg';
import { ReactComponent as AllergyIcon } from 'icons/pages/app/allergy.svg';
import { ReactComponent as InsuranceCompanyIcon } from 'icons/pages/app/insuranceCompany.svg';
import { ReactComponent as ParkingIcon } from 'icons/pages/app/parking.svg';
import { ReactComponent as GratitudeIcon } from 'icons/pages/app/gratitude.svg';
import { ReactComponent as HeartIcon } from 'icons/components/heart.svg';
//import { ReactComponent as PhoneIcon } from 'icons/components/phone.svg'; Будущий функционал
//import { ReactComponent as MessageIcon } from 'icons/components/message.svg';

import './index.less';
import './themes/default.less';

export default class HeaderClient extends MainComponent {
    static propTypes = {
        info: PropTypes.object,
        onToogleReturnVisit: PropTypes.func,
        visitOpened: PropTypes.bool,
    };

    static defaultProps = {
        info: false,
        onToogleReturnVisit: null,
        visitOpened: false,
    };

    async updateClient(key, value) {
        this.props.updateClient({ [key]: value });
    }

    renderSelectPersone(key) {
        return (
            <div
                className="selectPersone hand"
                onClick={this.props.openDialog.bind(this, "selectDoctor", null, this.updateClient.bind(this, key), key)}>
                {this.tr("main.choose")}
            </div>
        );
    }

    getFioPerson(info, key) {
        return (
            <div className="hand" onClick={this.props.openDialog.bind(this, "selectDoctor", info.id, this.updateClient.bind(this, key), key)}>
                {this._helper.string.formatFullName(info, "short")}
            </div>
        );
    }

    renderRow(title, component) {
        return (
            <div className="detailRow flex centerV gap24">
                <div className="rowTitle">{this.tr(title)}</div>
                <div className="flex1">{component}</div>
            </div>
        );
    }

    openDeleteDialog() {
        this._helper.confirm({
            title: "client.deleteCard",
            message: this.tr("client.deleteCardMessage")
        }, this.props.deleteClient);
    }

    getStatusClient(status, clientIconStatus, statusTreatment) {
        if (status === "PERMANENT" && clientIconStatus !== "REGULAR")
            status = "NOVICE";
        else if (status === "NOVICE" && clientIconStatus === "REGULAR")
            status = "PERMANENT";

        const req = this._helper.getClientStatus(status, true, statusTreatment);
        console.log("getStatusClient1", req);


        return req;
    }

    getMedSection(arr, src) {
        return (arr?.find(it => it.title === src) || {}).value;
    }

    getDiagnosis(f) {
        if (!f)
            return;

        const diagnosis = this._config.diagnosis;

        Object.keys(f).forEach(it => {
            if (f[it] && f[it].includes(",")) {
                const text = [];
                const arr = f[it].split(",");
                arr.forEach(item => {
                    const d = (diagnosis.find(diag => diag.id === +item) || {}).abb;
                    text.push(d);
                });
                f[it] = text.join(",");
            } else if (f[it]) {
                const d = (diagnosis.find(diag => diag.id === +f[it]) || {}).abb;
                f[it] = d;
            }
        });

        return f;
    }

    async printForm043() {
        const { id } = this.props.info;

        this._helper.showLoading();
        const inspection = await this._request.visits.getLastInspectionForClient(id);
        this._helper.hideLoading();

        if (inspection) {
            const { profileNumber, birthday, sex, personalData, phoneNumber } = this.props.info;
            this._helper.showLoading();
            const medInspection = await this._request.medInspection.getMedInspection(inspection.inspectionId);
            this._helper.hideLoading();

            const arrIns = inspection.inspection?.medInspectionHasMedSection;

            const fio = this._helper.string.formatFullName(this.props.info);
            const complaints = this.getMedSection(arrIns, "Жалобы");
            const diagnosis = this.getMedSection(arrIns, "Диагноз");
            const diagforICD = this.getMedSection(arrIns, "Диагноз по МКБ");
            const currentDisease = this.getMedSection(arrIns, "Развитие настоящего заболевания");
            const anamnesis = this.getMedSection(arrIns, "Анамнез жизни");
            const inspExternal = this.getMedSection(arrIns, "Внешний осмотр");
            const bite = "Не выбран";
            const dentalFormula = this.getDiagnosis((medInspection?.data[0] || {}).dentalFormula);

            const printInfo = {
                inspection,
                profileNumber,
                fio,
                birthday,
                sex,
                address: personalData?.REG_ADDRESS,
                phoneNumber,
                job: personalData?.JOB_KIND,
                complaints,
                diagnosis,
                diagforICD,
                currentDisease,
                anamnesis,
                inspExternal,
                bite,
                dentalFormula
            };
            this._print.form43u(printInfo);

            /*this.printShow("Inspection ", {
                clientId: id + "",
                inspectionId: inspectionId + "",
                date: this._helper.date.toDateServerStr(date),
            });*/
        } else {
            return this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("client.printError"),
                text: this.tr("client.noInformation"),
            });
        }
    }

    renderDisease(allergy, isHypertension) {
        let title = "client.allergy";
        let value = (<div className="redtext flex centerV gap8">
            <div className="chart9 flex" data-tooltip={allergy} data-tooltip-max-width={400}>
                <AllergyIcon />
            </div>
            <div className="pl5 textCut hidden">{allergy}</div>
        </div>);

        if (allergy && isHypertension) {
            title = "Заболевания";
            value = (<div className="redtext flex centerV gap8">
                <div className="flex" data-tooltip={"Гипертония"} data-tooltip-max-width={400}>
                    <HeartIcon />
                </div>
                <div className="chart9 flex" data-tooltip={allergy} data-tooltip-max-width={400}>
                    <AllergyIcon />
                </div>
                <div className="pl5 textCut hidden">{allergy}</div>
            </div>);
        } else if (isHypertension) {
            title = "Гипертония";
            value = (<div className="redtext flex centerV gap8">
                <div className="flex" data-tooltip={"Гипертония"} data-tooltip-max-width={400}>
                    <HeartIcon />
                </div>
                <div className="pl5 textCut hidden">{allergy}</div>
            </div>);
        }

        return this.renderRow(title, value);

    }

    render() {
        const { visitOpened, info, onToogleReturnVisit } = this.props;
        const { photoUid, birthday, phoneNumber, profileNumber, doctor, doctorHygienist, coordinator,
            personalData, sex, status, vipStatus, clientIconStatus, lkSearchAttr1, commercialEnable,
            contactName, allergy, isHypertension, smileKeeper, isEmployee, visitRules,
            insurance, patientVehicle, isGratitude, statusTreatment } = info;

        const { SPEC_NOTES } = personalData || {};
        const fullName = `${this._helper.string.formatFullName(info)} ${contactName ? "(" + contactName + ")" : ""}`;
        const canSeeDelete = this._helper.checkProfilePermissions("clientDeleteButton");

        const { whatsapp, telegram, sms, phone, email, push } = (commercialEnable || {});
        const tooltipNotif = (whatsapp || telegram || sms || phone || email || push) ?
            `${whatsapp ? "WhatsApp" : ""} ${telegram ? "Telegram" : ""} ${sms ? "SMS" : ""} 
            ${phone ? "Телефон" : ""} ${email ? "Email" : ""} ${push ? "Push" : ""}` : false;

        let bdLabel = "";
        let ageLabel = "";
        let age = 100;
        if (birthday) {
            bdLabel = this._helper.date.toStr(birthday, "DD MMMM YYYY");
            ageLabel = this._helper.date.getAgeStr(birthday);
            age = this._helper.date.getAge(birthday);
        }

        const isChild = age < this._config.childAge;

        let circle = false;
        const vr = (visitRules || []).filter(it => it.status === "NEW");
        if (vr?.length) {
            circle = vr?.filter(it => it.status === "NEW")?.some(it => {
                const diff = (new Date(it.nextDate) - new Date()) / (1000 * 60 * 60 * 24);
                if (diff < 30 && diff > 0)
                    return true;
                return false;
            }) ? "red" : "green";
        }

        const { vehicles, parkingPriority } = (patientVehicle || {});
        const modePark = (!parkingPriority || parkingPriority === "NOT_NECESSARY") ? 0 :
            parkingPriority === "REQUIRED" ? 1 : 2;
        let textParking = "";
        if (modePark) {
            if (modePark === 2)
                textParking = "Сразу оформлять ";
            else
                textParking = "Спрашивать ";

            (vehicles || []).forEach(it => {
                textParking += `${it.mark} ${it.number} `;
            });
        }

        return (
            <div className={`headerClient flex gap24 ${status === "PASSED_AWAY" ? "grayscale" : ""}`}>
                <Avatar
                    id={photoUid}
                    sex={sex}
                    size={120}
                    radius={8}
                    iconWidth={77}
                    iconHeight={103}
                />
                <div className="headerContent flex col flex1 gap24">
                    <div className="firstRow flex between centerV">
                        <div className="flex gap16">
                            <div>
                                <div className="text pageTitle selectable">{fullName}</div>
                                <div className="text p2 gray3">{profileNumber}</div>
                            </div>
                            {/*<div className="flex gap8"> Будущий функционал
                                <div className="hand"><PhoneIcon /></div>
                                <div className="hand"><MessageIcon /></div>
                            </div>*/}
                        </div>

                        <div className="flex buttons gap16">
                            <Button
                                type={"secondary"}
                                size={"small"}
                                label={"client.form043u"}
                                icon={<PrintIcon />}
                                onClick={this.printForm043.bind(this)}
                            />
                            <div className="pos rel">
                                {circle ? <div className={`circle text p2 pos abs flex centerAll ${circle}`}>
                                    {vr.length}
                                </div> : <div></div>}
                                <Button
                                    type={"stroke"}
                                    size={"small"}
                                    label={"client.returnVisits"}
                                    active={visitOpened}
                                    onClick={onToogleReturnVisit}
                                />
                            </div>

                            {canSeeDelete && (
                                <Button
                                    type={"warning"}
                                    size={"small"}
                                    label={"client.delete"}
                                    onClick={this.openDeleteDialog.bind(this)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="details flex between text p1">
                        <div className="detailsRows flex col gap8">
                            {this.renderRow("client.dateBirth", (
                                birthday ? (<div className="selectable">{bdLabel} <span>{ageLabel} </span></div>) : (this.tr("main.notIndicated"))
                            ))}
                            {this.renderRow("client.tel", <div className="selectable">
                                {this._helper.string.fromatPhone(phoneNumber)} {lkSearchAttr1 && <span>{this.tr("client.basicPhone")}</span>}</div>)}
                            {this.renderRow("client.specMarks", (
                                SPEC_NOTES ? (
                                    <div className="redtext flex centerV gap8">
                                        <div className="flex" data-tooltip={SPEC_NOTES} data-tooltip-max-width={400}>
                                            <SpecialInfoIcon />
                                        </div>
                                        <div className="pl5 textCut hidden">{SPEC_NOTES}</div>
                                    </div>
                                ) : <></>
                            ))}
                        </div>
                        <div className="detailsRows flex col gap8">
                            {this.renderRow("client.status", <div className="flex centerV gap8">
                                {this.getStatusClient(status, clientIconStatus, statusTreatment)}
                            </div>)}
                            {this.renderRow("client.marks", <div className="flex centerV gap8">
                                {tooltipNotif ? <div data-tooltip={tooltipNotif}>
                                    <AdvertIcon />
                                </div> : <AdvertDisableIcon />}
                                {!!vipStatus && <VipIcon />}
                                {isChild && <ChildrenIcon />}
                                {smileKeeper && <SmileKeeperIcon />}
                                {isEmployee && <EmployeeIcon />}
                                {isGratitude && <div data-tooltip={"Программа благодарности"}><GratitudeIcon /></div>}
                                {insurance?.name && <div data-tooltip={insurance.name}><InsuranceCompanyIcon /></div>}
                                {textParking && <div data-tooltip={textParking}><ParkingIcon /></div>}
                            </div>)}
                            {(allergy || isHypertension) ? this.renderDisease(allergy, isHypertension) : false}
                        </div>
                        <div className="detailsRows flex col gap8">
                            {this.renderRow("client.doctor", doctor?.id ? this.getFioPerson(doctor, "doctorId") : this.renderSelectPersone("doctorId"))}
                            {this.renderRow("client.hygienist", doctorHygienist?.id ? this.getFioPerson(doctorHygienist, "doctorHygienistId") : this.renderSelectPersone("doctorHygienistId"))}
                            {this.renderRow("client.coordinator", coordinator?.id ? this.getFioPerson(coordinator, "coordinatorId") : this.renderSelectPersone("coordinatorId"))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

